var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniphoreLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6035 21.2996L13.282 13.8717C13.4459 13.1393 14.0275 12.5688 14.7692 12.4069L20.4642 11.1696L21.12 8.27478L12.4896 10.152C11.748 10.3139 11.1703 10.8844 11.0063 11.6129L8.67212 21.9356L11.6035 21.2996Z",
    fill: "url(#paint0_linear_51_546)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64945 22.1629L10.1749 10.9845C10.3389 10.2521 10.9205 9.6816 11.6621 9.52356L21.3151 7.42279L21.9709 4.52795L9.38645 7.26475C8.64481 7.42664 8.06711 7.99713 7.90317 8.72565L4.72192 22.7989L7.65335 22.1629H7.64945Z",
    fill: "url(#paint1_linear_51_546)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8367 0.553921L19.6133 19.2335C19.4493 19.9659 18.8677 20.5364 18.1261 20.6982L3.50016 23.8783L7.06784 8.08973C7.23178 7.35735 7.81338 6.79072 8.55112 6.62883L22.1583 3.66847L22.814 0.773635L6.27155 4.37387C5.52991 4.53576 4.95221 5.10625 4.78827 5.83477L0.00664587 27.0006C-0.0362912 27.1933 0.135457 27.3629 0.330625 27.3205L20.5774 22.9185C21.2136 22.7797 21.7133 22.2902 21.8577 21.658L26.6744 0.326498C26.7174 0.133766 26.5456 -0.0358381 26.3505 0.0065629L23.8328 0.553921H23.8367Z",
    fill: "url(#paint2_linear_51_546)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9438 3.44491L22.7203 22.1245C22.5564 22.8569 21.9748 23.4273 21.2331 23.5892L3.67188 27.4092L3.1098 29.8916C3.06686 30.0843 3.23861 30.2539 3.43377 30.2115L23.6805 25.8095C24.3168 25.6707 24.8164 25.1812 24.9608 24.549L29.7815 3.21749C29.8244 3.02476 29.6527 2.85515 29.4575 2.89755L26.9399 3.44491H26.9438Z",
    fill: "url(#paint3_linear_51_546)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0508 6.33578L25.8274 25.0153C25.6634 25.7477 25.0818 26.3182 24.3402 26.4801L6.77894 30.3L6.21685 32.7824C6.17391 32.9752 6.34566 33.1448 6.54083 33.1024L26.7876 28.7004C27.4238 28.5616 27.9235 28.0721 28.0679 27.4399L32.8886 6.10836C32.9315 5.91563 32.7597 5.74602 32.5646 5.78842L30.0469 6.33578H30.0508Z",
    fill: "url(#paint4_linear_51_546)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1579 9.22689L28.9344 27.9065C28.7705 28.6388 28.1889 29.2093 27.4472 29.3712L9.88599 33.1912L9.32391 35.6735C9.28097 35.8663 9.45272 36.0359 9.64789 35.9935L29.8946 31.5915C30.5309 31.4527 31.0305 30.9632 31.175 30.331L35.9956 8.99947C36.0386 8.80674 35.8668 8.63714 35.6716 8.67954L33.154 9.22689H33.1579Z",
    fill: "url(#paint5_linear_51_546)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_546",
    x1: 7.50554,
    y1: 16.7137,
    x2: 22.2635,
    y2: 13.4224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F6FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B76E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_546",
    x1: 3.16921,
    y1: 15.8726,
    x2: 23.4862,
    y2: 11.3416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F6FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B76E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_546",
    x1: -2.24005,
    y1: 17.0491,
    x2: 28.8827,
    y2: 10.1083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F6FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B76E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_546",
    x1: 0.867051,
    y1: 19.9415,
    x2: 31.9899,
    y2: 13.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F6FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B76E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_546",
    x1: 3.97416,
    y1: 22.8337,
    x2: 35.097,
    y2: 15.8929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F6FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B76E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_546",
    x1: 7.08126,
    y1: 25.7262,
    x2: 38.2041,
    y2: 18.7854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F6FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B76E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniphoreLogo);
export default __webpack_public_path__ + "static/media/uniphore_logo.8ae1e293.svg";
export { ForwardRef as ReactComponent };